import { useState, useEffect, forwardRef } from 'react';
import { getNotificationTypeIcon, getTimeAgo } from './Notifications';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router';

export const NotificationTray = forwardRef(({ notifications, fetchNotifications }, ref) => {
    const navigate = useNavigate();

    const readNotification = async (notification) => {
        try {
            const response = await fetch(`https://api.casedb.co/notifications.php?read=${notification.id}`, {
                method: 'GET',
                credentials: 'include'
            });
            const data = await response.json();
            if (data.success) {
                fetchNotifications();
            }
        } catch (error) {
            console.error("Error marking notification as read:", error);
        }

        if (notification.url) {
            navigate(notification.url ? notification.url.startsWith("/") ? `${notification.url}${notification.foreign_identifier ? `?key=${notification.foreign_identifier}` : ''}` : `/${notification.url}${notification.foreign_identifier ? `?key=${notification.foreign_identifier}` : ''}` : null);
        }
    }

    return (
        <div className='notification-tray' ref={ref}>
            <div className='notification-tray-header'>
                <p className='subtext'>Notifications ({notifications.length})</p>
                <span className='nav-to-notis' title="See all notifications" onClick={() => navigate('/notifications')}><ArrowRight size={16}/></span>
            </div>
            {notifications.length > 0 ? (
                notifications.slice(0, 4).map((notification, index) => (
                    <div className='notification-tray-item subtext' key={index} onClick={() => readNotification(notification)} style={{cursor: notification.url ? 'pointer' : 'default'}}>
                        <span className="notification-tray-message">
                            <span className='notification-tray-icon'>
                                {getNotificationTypeIcon(notification.type, 16, notification)}
                            </span>
                            {!notification.read_at && <div className='notification-new'></div>}
                            {notification.title.length > 32 ? `${notification.title.slice(0, 32)}...` : notification.title}
                        </span>
                        <span className="notification-time">
                            {getTimeAgo(notification.created_at_local)}
                        </span>
                    </div>
                ))
            ) : (
                <div className='notification-tray-empty'>
                    <p className='no-new-notis'>No new notifications</p>
                </div>
            )}
        </div>
    )
});